import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

// import Dashboard from "./pages/Dashboard";
import Admins from "./pages/Admin";
import Projects from "./pages/Projects";
import AddProject from "./pages/Projects/AddProject";
import Banners from "./pages/Banners";
import Static from "./pages/Static";
import Home from "./pages/Home";
import Leadership from "./pages/Leadership";
import AddLeadership from "./pages/Leadership/AddLeadership";
import SocialMedia from "./pages/Settings/Social";
import ContactUs from "./pages/ContactUs";
import Gallery from "./pages/Gallery";

const Markup = () => {
	const allroutes = [
		// Admins
		{ url: "/", component: <Admins /> },

		// Home
		{ url: "home", component: <Home /> },

		// Leadership
		{ url: "leadership-ourboard", component: <Leadership /> },
		{ url: "leadership-ourboard/add-leadership", component: <AddLeadership /> },

		// Projects
		{ url: "projects", component: <Projects /> },
		{ url: "projects/add-project", component: <AddProject /> },
		{ url: "projects/edit-project", component: <AddProject /> },

		// Media Center
		{ url: "media-center", component: <Projects /> },
		{ url: "media-center/add-media", component: <AddProject /> },
		{ url: "media-center/edit-media", component: <AddProject /> },

		// Setting
		// { url: "company-logo", component: <CompanyLogo /> },

		// Banners
		{ url: "/banners", component: <Banners /> },

		// ContactUs
		{ url: "/contact-us", component: <ContactUs /> },

		// Gallery
		{ url: "/gallery", component: <Gallery /> },

		// Static
		{ url: "/static", component: <Static /> },
		{ url: "/social", component: <SocialMedia /> },

		// Profile
		// { url: "profile", component: <Profile /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper overflow-auto" className={`show `}>
			<Nav />
			<div
				className="content-body"
				style={{ minHeight: window.screen.height - 45 }}>
				<div className="container-fluid">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default Markup;
